import { tryOnBeforeMount } from '@vueuse/core'

export function useForeignDomain(_path: MaybeRef<string>) {
  const config = useRuntimeConfig()
  const nuxtApp = useNuxtApp()
  const req = useRequestURL()
  const route = useRoute()

  tryOnBeforeMount(() => {
    init()
  })

  function init() {
    const isCookieMichelin = !!nuxtApp.$cookiz.get('MICHELIN')
    const host = req.host
    const isMichelinDomain = new RegExp(config.public.MICHELIN_DOMAIN).test(host)

    if (route.name) {
      const isRestrictPath = route.name.toString().includes('booking-id')
      if (!isRestrictPath) {
        nuxtApp.$store.dispatch('setHideHeaderItems', false)
        nuxtApp.$store.dispatch('setHideFooter', false)
      }
    }

    if (isMichelinDomain) {
      if (!isCookieMichelin) {
        nuxtApp.$cookiz.set('MICHELIN', true, { path: '/' })
      }
      nuxtApp.$store.dispatch('setForeignDomainFromMichelin', 'Michelin')
    } else if (isCookieMichelin) {
      nuxtApp.$cookiz.remove('MICHELIN')
    }

    const isCookieCathay = nuxtApp.$cookiz.get('HideNav') === 'cathay' || false
    if (isCookieCathay) {
      nuxtApp.$store.dispatch('setForeignDomainFromCathay', isCookieCathay)
    }
  }
}
